import React from "react";
import {
  CarrosseulCard,
  Headline,
  SectionContent,
} from "../../../../components";
import * as S from "./CoberturasBasicas.Style";

const CoberturasBasicas = () => {
  return (
    <S.CoberturarBasicasContent as={SectionContent}>
      <S.SectionHeadline
        as={Headline}
        nivel="2"
        styleAs="4"
        text="Coberturas Básicas"
        reset={{ textAlign: "center" }}
        leadMobile
      />
      <S.Carroussel as={CarrosseulCard}>
        <CarrosseulCard.CardItem title="Incêndio">
          Se ocorrer um incêndio de qualquer natureza no imóvel, você poderá
          receber até 100% do valor dessa cobertura para reparar danos causados
          ao imóvel e aos seus bens.
        </CarrosseulCard.CardItem>
        <CarrosseulCard.CardItem title="Queda de raio">
          Se um raio cair no terreno do imóvel, você recebe até 100% do valor
          dessa cobertura para reparar danos causados ao imóvel. A cobertura não
          inclui o reembolso para danos elétricos.
        </CarrosseulCard.CardItem>
        <CarrosseulCard.CardItem title="Explosão">
          Em caso de explosão de qualquer natureza, originada dentro da área de
          seu terreno, você recebe até 100% do valor dessa cobertura para
          reparar danos causados ao imóvel e aos seus bens.
        </CarrosseulCard.CardItem>
      </S.Carroussel>
    </S.CoberturarBasicasContent>
  );
};

export default CoberturasBasicas;
